module.exports = __webpack_public_path__ + "img/account-part_gold.56e89585.svg";